import { render, staticRenderFns } from "./ProjectLogDisputeList.vue?vue&type=template&id=68e62fea&"
import script from "./ProjectLogDisputeList.vue?vue&type=script&lang=js&"
export * from "./ProjectLogDisputeList.vue?vue&type=script&lang=js&"
import style0 from "./ProjectLogDisputeList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports